export const COLOR_WHITE = '#ffffff';
